import React, { useEffect, useState } from 'react';
import Content from '../Content';
import { RowInner,ColCard } from 'utils/formStyles';
import FormDivider from 'components/FormDivider';
import { Button } from '@material-ui/core';
import { useDispatch,connect } from 'react-redux';
import { getService } from 'reducers/service';
import SaveIcon from '@material-ui/icons/Save';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';
import Checkbox2 from 'components/Checkbox2';
import { getPasswordValidation } from 'reducers/ConfigReducer';

function PasswordSettings(props) {
  const cdrService = getService('cdr');

  const [requireLowercase, setRequireLowercase] = useState(false);
  const [requireLowercaseEditMode, setRequireLowercaseEditMode] = useState(false);
  const [requireUppercase, setRequireUppercase] = useState(false);
  const [requireUppercaseEditMode, setRequireUppercaseEditMode] = useState(false);
  const [requireDigit, setRequireDigit] = useState(false);
  const [requireDigitEditMode, setRequireDigitEditMode] = useState(false);
  const [requireSpecialChar, setRequireSpecialChar] = useState(false);
  const [requireSpecialCharEditMode, setRequireSpecialCharEditMode] = useState(false);

    const dispatch = useDispatch();

  useEffect(() => {
    if (props.wsClient.websocket) {
      searchPasswordSettings();
    }
  }, [props.dictionary, props.wsClient]);
  

  const getCDRValue = async (path, key, setEditMode, setValue, isBoolean = false) => {
    const data = await cdrService.get({ Path: path, CDRKey: key });
    const item = data?.[0];
    if (!item) return;

    setEditMode(true);

    if (isBoolean) {
      setValue(Boolean(item.ValueBoolean));
    } else {
      setValue(item.ValueNumeric ?? 0);
    }
  };
  
  const saveCDR = (edit, Path, CDRKey, value, type = 'numeric') => {
    const payload = { Path, CDRKey };
    if (type === 'boolean') {
      payload.ValueBoolean = value;
    } else {
      payload.ValueNumeric = value;
    }
    return edit ? cdrService.patch(null, payload) : cdrService.create(payload);
  };

  const searchPasswordSettings = async () => {
    await getCDRValue('Password.RequireUppercase', 'PasswordValidation', setRequireUppercaseEditMode, setRequireUppercase,true);
    await getCDRValue('Password.RequireLowercase', 'PasswordValidation', setRequireLowercaseEditMode, setRequireLowercase,true);
    await getCDRValue('Password.RequireDigit', 'PasswordValidation', setRequireDigitEditMode, setRequireDigit,true);
    await getCDRValue('Password.RequireSpecialChar', 'PasswordValidation', setRequireSpecialCharEditMode, setRequireSpecialChar,true);
  };

  const handleSaveClick = async () => {
    try {
      await handlePasswordSettingSave();
      await dispatch(getPasswordValidation());
      dispatch(notify('Settings Saved.', 'success'));
    } catch (err) {
      dispatch(notify('Could not Saved.', 'error'));
    }
  };

  const handlePasswordSettingSave = async () => {
    try {
      await saveCDR(
        requireUppercaseEditMode,
        'Password.RequireUppercase',
        'PasswordValidation',
        requireUppercase,
        'boolean'
      );
  
      await saveCDR(
        requireLowercaseEditMode,
        'Password.RequireLowercase',
        'PasswordValidation',
        requireLowercase,
        'boolean'
      );
  
      await saveCDR(
        requireDigitEditMode,
        'Password.RequireDigit',
        'PasswordValidation',
        requireDigit,
        'boolean'
      );
  
      await saveCDR(
        requireSpecialCharEditMode,
        'Password.RequireSpecialChar',
        'PasswordValidation',
        requireSpecialChar,
        'boolean'
      );
  
    } catch (err) {
      props.handleError(err, 'Error Saving Password Settings.');
    }
  };

  //ui parts
  const renderPasswordLower = () => {
    return (
      <Checkbox2
        size="small"
        checked={requireLowercase}
        onChange={e => setRequireLowercase(e.target.checked)}
        label="Require Lowercase Letter"
        tooltipText="When enabled, the password must contain at least one lowercase letter (a–z)."
      />
    );
  };
  const renderPasswordUpper = () => {
    return (
      <Checkbox2
        size="small"
        checked={requireUppercase}
        onChange={e => setRequireUppercase(e.target.checked)}
        label="Require Uppercase Letter"
        tooltipText="When enabled, the password must contain at least one uppercase letter (A–Z)."
      />
    );
  };
  const renderPasswordDigit = () => {
    return (
      <Checkbox2
        size="small"
        checked={requireDigit}
        onChange={e => setRequireDigit(e.target.checked)}
        label="Require Numeric Character"
        tooltipText="When enabled, the password must contain at least one numeric digit (0–9)."
      />
    );
  };
  
  const renderPasswordSpecial = () => {
    return (
      <Checkbox2
        size="small"
        checked={requireSpecialChar}
        onChange={e => setRequireSpecialChar(e.target.checked)}
        label="Require Special Character"
        tooltipText="When enabled, the password must contain at least one special character (e.g., ! @ # $ %)."
      />
    );
  }; 

  const renderSaveBtn = () => {
    return (
      <div className="text-right pb-4">
        <Button onClick={handleSaveClick} variant="contained" color="primary">
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };

  return (
    <Content>
      <div className="m-4 mt-0">
        {renderSaveBtn()}
        <ColCard minWidth={500}>
          <FormDivider title="Password Settings" />
          <RowInner className="mt-2">{renderPasswordLower()}</RowInner>
          <RowInner className="mt-2">{renderPasswordUpper()}</RowInner>
          <RowInner className="mt-2">{renderPasswordDigit()}</RowInner>
          <RowInner className="mt-2">{renderPasswordSpecial()}</RowInner>
        </ColCard>
      </div>
    </Content>
  );
}
const mapStateToProps = state => {
  return {
    dictionary: state.dictionary,
    wsClient: state.websocket,
  };
};

export default connect(mapStateToProps, {
  handleError,
  notify,
})(PasswordSettings);
